import React, { useEffect, useState } from 'react'
import Svg, { Circle, Defs, Stop, LinearGradient } from 'react-native-svg'
import { VictoryPie } from 'victory-native'
import { View, Image, Platform } from 'react-native'

const initData = [
  { y: 0, fill: 'none' },
  { y: 100, fill: 'none' },
]

export const TopicWheel = (props: any) => {
  const { value, style, image, id } = props
  const fillValue = Math.round((value ?? 0) * 100)

  const miamiId = `Miami_RW_${id}`
  const miamiIdLight = `MiamiImg_RW_${id}`

  const fillColor = `url(#${miamiId})`
  const strokeColor = `url(#${miamiIdLight})`
  const size = 42

  const [finalData, setFinalData] = useState(initData)

  useEffect(() => {
    const timer = setTimeout(() => {
      setFinalData([
        { y: fillValue, fill: fillColor },
        { y: 100 - fillValue, fill: 'none' },
      ])
    }, 1000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <View style={{ width: size, height: size, ...style }}>
      <Svg viewBox="0 0 80 80" height={size} width={size}>
        <Defs>
          <LinearGradient id={miamiId}>
            <Stop offset="0%" stopColor="#FFBF1A" />
            <Stop offset="100%" stopColor="#FF4080" />
          </LinearGradient>
          <LinearGradient id={miamiIdLight}>
            <Stop offset="0%" stopColor="#FFBF1A20" />
            <Stop offset="100%" stopColor="#FF408020" />
          </LinearGradient>
        </Defs>
        <Circle
          cx={40}
          cy={40}
          r={35}
          stroke={Platform.OS === 'web' ? strokeColor : `#FF408020`}
          strokeWidth={8}
          fill="none"
        />
        <VictoryPie
          labelComponent={<></>}
          standalone={false}
          height={42}
          width={42}
          radius={32}
          origin={{ x: 40, y: 40 }}
          innerRadius={39}
          cornerRadius={5}
          animate={{ easing: 'sin', duration: 2000 }}
          data={finalData}
          style={{
            labels: { display: 'none' },
            data: {
              fill: ({ datum }) => datum.fill,
              opacity: ({ datum }) => datum.opacity,
            },
          }}
        />
      </Svg>
    </View>
  )
}
